import { OutcomeAnalysisRequest } from '../../api-models/types.gen';
import { CohortType } from '../../types/enums';
import { FrontendFilterValue } from '../../types/filters.type';

export interface OutcomeTrackerAdaptRequestProps {
  selectedCohort: string;
  campaign: string;
  householdReferences: FrontendFilterValue[];
  snapshots: { start: string; end: string };
  savedCohortId?: string;
}

export default function outcomeTrackerAdaptRequest(request: OutcomeTrackerAdaptRequestProps): OutcomeAnalysisRequest {
  const {
    selectedCohort, campaign, householdReferences, snapshots, savedCohortId
  } = request;
  const { start: startSnapshot, end: endSnapshot } = snapshots;

  const sourceByType: Record<string, OutcomeAnalysisRequest['source']> = {
    [CohortType.Campaign]: { type: CohortType.Campaign, campaign_communication_id: Number(campaign) },
    [CohortType.HouseholdReferences]: {
      type: CohortType.HouseholdReferences,
      household_references: householdReferences.map((ref) => ref.displayName),
    },
    [CohortType.Cohort]: { type: CohortType.Cohort, cohort_id: Number(savedCohortId) },
  };
  return {
    source: sourceByType[selectedCohort],
    start_snapshot: startSnapshot,
    end_snapshot: endSnapshot,
  };
}
